
































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import processdto from '@/store/entities/workorder/processworkorderpo';
import workorderActionEnum from '@/store/enums/workorderenum';



@Component({
    components: {},
})
export default class TransmitWorkOrder extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop({ type: Number, default: 0 }) workorderId: number;
    entityDto: processdto = new processdto();
    loading: boolean = false;
    /**用户列表 */
    userlist: any[] = [];
    create() { }
    created() {
        this.getuserlist();
    }
    /**获取处理人列表 */
    getuserlist() {
        this.$store.dispatch("user/getallusers")
            .then((data) => {
                this.userlist = [];
                if (data.length > 0) {
                    data.forEach((ele) => {
                        this.userlist.push({ value: ele.id, label: ele.name })
                    });
                }
            })
    }
    /**保存 */
    save() {
        (this.$refs.itemForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.loading = true;
                this.entityDto.actionId = workorderActionEnum.Transfer;
                let res = await this.$store
                    .dispatch({
                        type: "workorder/processWorkOrder",
                        data: this.entityDto,
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.$Modal.info({
                            title: this.L("Tips"),
                            content: err,
                        });
                    });
                this.$Modal.info({
                    title: this.L("Tips"),
                    content: res.data.result,
                });
                this.loading = false;
                (this.$refs.itemForm as any).resetFields();
                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    /**处理人 */
    changename(choosedItem: any) {
        if (choosedItem != undefined) {
            this.entityDto.assignerName = choosedItem.label;
        }
    }
    cancel() {
        (this.$refs.itemForm as any).resetFields();
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
        }
    }
    /**规则 */
    itemRule = {
        assignerID: [
            {
                type: 'number',
                required: true,
                message: this.L("FieldIsRequired"),
                trigger: "blur",
            },
        ],
    };
    @Watch("workorderId")
    getitemId() {
        this.entityDto.workId = this.workorderId;
    }
}
